/*=========================================================================================
  File Name: moduleCompanyMutations.js
  Description: Company Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	ADD_COMPANY(state, item) {
		state.companies.unshift(item);
	},
	SET_COMPANIES(state, companies) {
		state.companies = companies;
	},
	UPDATE_COMPANY(state, product) {
		const productIndex = state.companies.findIndex((p) => p.id === product.id);
		Object.assign(state.companies[productIndex], product);
	},
	REMOVE_COMPANY(state, itemId) {
		const ItemIndex = state.companies.findIndex((p) => p.id === itemId);
		state.companies.splice(ItemIndex, 1);
	},
};
